import { ReactNode } from "react";

export function Svg({ size = 24, children }: { size?: number; children: ReactNode }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      {children}
    </svg>
  );
}

export const Users = () => (
  <Svg><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M22 21v-2a4 4 0 0 0-3-3.87" /><path d="M16 3.13a4 4 0 0 1 0 7.75" /></Svg>
);
export const User = () => (
  <Svg><path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" /><circle cx="12" cy="7" r="4" /></Svg>
);
export const Spark = () => (
  <Svg><path d="M12 3l1.2 4.2L17.5 8.5 13.2 9.8 12 14l-1.2-4.2L6.5 8.5l4.3-1.3z" /><path d="M19 14v3" /><path d="M17.5 15.5h3" /></Svg>
);
export const Ribbon = () => (
  <Svg><path d="M12 11c-1-1.2-2-2.2-2-3.2a2 2 0 1 1 4 0c0 1-1 2-2 3.2z" /><path d="M7 8a7 7 0 0 1 10 0" /><path d="M8 20l4-6 4 6-2 1.2L12 18l-2 3.2z" /></Svg>
);
export const Flower = () => (
  <Svg><circle cx="12" cy="8" r="2.2" /><path d="M12 10v11" /><path d="M12 21c3.2 0 5-1.2 5-3.6-3.2 0-5 1.2-5 3.6z" /><path d="M12 21c-3.2 0-5-1.2-5-3.6 3.2 0 5 1.2 5 3.6z" /></Svg>
);
export const Heart = () => (
  <Svg><path d="M19 14c1.5-1.5 2.5-2.8 2.5-4.5a5 5 0 0 0-8.5-3.5 5 5 0 0 0-8.5 3.5C4.5 11.2 6 12.8 7.5 14.2L12 19l4.5-5z" /></Svg>
);
export const Brain = () => (
  <Svg><path d="M12 18V6" /><path d="M8 12a4 4 0 1 1 8 0" /><path d="M7 8a3 3 0 1 1 5-2 3 3 0 1 1 5 2" /><path d="M6 16a4 4 0 1 1 6 2 4 4 0 1 1 6-2" /></Svg>
);
export const Mail = ({ size = 18 }) => (
  <Svg size={size}><rect x="3" y="5" width="18" height="14" rx="2" /><path d="m3 7 9 6 9-6" /></Svg>
);
export const Phone = () => (
  <Svg size={18}><path d="M22 16.9v2a2 2 0 0 1-2.2 2 19 19 0 0 1-8.3-3 19 19 0 0 1-6-6 19 19 0 0 1-3-8.3A2 2 0 0 1 4.1 2h2a2 2 0 0 1 2 1.7c.1.9.3 1.8.6 2.6a2 2 0 0 1-.5 2.1L7.1 9.5a16 16 0 0 0 6 6l1.1-1.1a2 2 0 0 1 2.1-.5c.8.3 1.7.5 2.6.6a2 2 0 0 1 1.7 2z" /></Svg>
);
export const Pin = () => (
  <Svg size={18}><path d="M20 10c0 5-8 12-8 12S4 15 4 10a8 8 0 0 1 16 0z" /><circle cx="12" cy="10" r="2.5" /></Svg>
);
export const Ig = () => (
  <Svg size={18}><rect x="3" y="3" width="18" height="18" rx="5" /><circle cx="12" cy="12" r="4" /><circle cx="17.5" cy="6.5" r="0.8" fill="currentColor" stroke="none" /></Svg>
);
export const Fb = () => (
  <Svg size={18}><path d="M14 8h2V5h-2c-2.2 0-4 1.8-4 4v2H8v3h2v7h3v-7h2.2l.8-3H13V9c0-.6.4-1 1-1z" /></Svg>
);
export const Down = ({ size = 18 }) => (
  <Svg size={size}><path d="M12 15V3" /><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" /><path d="m7 10 5 5 5-5" /></Svg>
);
export const Arrow = () => (
  <Svg size={16}><path d="M5 12h14" /><path d="m12 5 7 7-7 7" /></Svg>
);
export const Shield = () => (
  <Svg size={22}><path d="M12 3 5 6v6c0 4.5 3 7 7 8 4-1 7-3.5 7-8V6z" /><path d="m9 12 2 2 4-4" /></Svg>
);
